import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useAsync } from 'react-use';
import { getAlgoliaSearchKey } from 'services/networking/content';

var useAlgoliaSearchKey = function useAlgoliaSearchKey() {
  var intl = useIntl();

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var _useAsync = useAsync( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAlgoliaSearchKey();

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []),
      loading = _useAsync.loading,
      error = _useAsync.error,
      value = _useAsync.value;

  useEffect(function () {
    if (error) {
      enqueueSnackbar(intl.formatMessage({
        id: 'algolia.error'
      }), {
        variant: 'error'
      });
    }
  }, [error, enqueueSnackbar, intl]);
  return {
    loading: loading,
    error: error,
    ALGOLIA_SEARCH_KEY: value
  };
};

export default useAlgoliaSearchKey;